import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJenkinsComponent } from './simple-icons-jenkins.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJenkinsComponent ],
    exports:      [ SimpleIconsJenkinsComponent ],
    bootstrap:    []
})
export class SimpleIconsJenkinsModule {}
